// extracted by mini-css-extract-plugin
module.exports = {"OrgUserListUnitBase":"OrgUserListUnitMemberPrimary_OrgUserListUnitBase__3f3pj","OrgUserListUnitUser":"OrgUserListUnitMemberPrimary_OrgUserListUnitUser__3i6lS"};